var map = {
	"./advantages-of-ocr-technology.html": "d995",
	"./cant-find-your-business-cards.html": "6173",
	"./cant-find-your-shopping-receipts.html": "da7b",
	"./how-to-use-scanner-plus.html": "2434",
	"./importance-of-digital-signature-in-remote-life.html": "48e0",
	"./increase-your-productivity-in-school.html": "b8ac",
	"./keep-all-your-documents-secure.html": "d156",
	"./scanner-plus-for-business-and-hr-management.html": "461e",
	"./support-homeschool.html": "2db1",
	"./what-is-ocr.html": "dbce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ad5";